var map = {
	"./assets/background.svg": 25998,
	"./assets/dataBoard/accounts_payable.svg": 6794,
	"./assets/dataBoard/accounts_receivable.svg": 73174,
	"./assets/dataBoard/annual_cumulative_procurement.svg": 54233,
	"./assets/dataBoard/annual_cumulative_sales.svg": 41451,
	"./assets/dataBoard/annual_profit.svg": 13545,
	"./assets/dataBoard/daily_procurement.svg": 40979,
	"./assets/dataBoard/daily_sales.svg": 12225,
	"./assets/dataBoard/inventory.svg": 13955,
	"./assets/dataBoard/inventory_amount.svg": 59914,
	"./assets/dataBoard/lost_customers.svg": 72677,
	"./assets/dataBoard/monthly_cumulative_procurement.svg": 16977,
	"./assets/dataBoard/monthly_cumulative_sales.svg": 12963,
	"./assets/dataBoard/monthly_profit.svg": 5937,
	"./assets/dataBoard/net_new_customers.svg": 14955,
	"./assets/dataBoard/new_customers.svg": 2243,
	"./assets/dataBoard/next_month_payable_bills.svg": 79297,
	"./assets/dataBoard/order_quantity.svg": 50777,
	"./assets/dataBoard/returns.svg": 32846,
	"./assets/default_head.png": 12532,
	"./assets/home/1.svg": 81759,
	"./assets/home/2.svg": 2732,
	"./assets/home/3.svg": 50093,
	"./assets/home/4.svg": 21570,
	"./assets/home/5.svg": 25299,
	"./assets/home/6.svg": 64288,
	"./assets/home/7.svg": 78673,
	"./assets/logo.png": 33153,
	"./assets/welcome.jpg": 34482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15353;